import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=32c02c0e&scoped=true"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=32c02c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c02c0e",
  null
  
)

export default component.exports